/* SMITHS — Gold price in Kuwait today. Progressive extras on a page that is complete without JavaScript:
   1. the "weigh your piece" calculator;
   2. a quiet refresh: if the printed price is older than 30 minutes while the market trades (or the page was
      rendered before the first snapshot existed), read the public metals endpoint and update the numbers in place. */
(function () {
  'use strict';
  const root = document.querySelector('[data-sg]');
  if (!root) return;
  const lang = root.getAttribute('data-lang') === 'ar' ? 'ar' : 'en';
  const f = (dp) => new Intl.NumberFormat('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  const f3 = f(3), f2 = f(2);

  /* ---------- 1. calculator ---------- */
  let prices = null;
  try { prices = JSON.parse((root.querySelector('[data-sg-prices]') || {}).textContent || 'null'); } catch (e) { prices = null; }
  const calc = root.querySelector('[data-sg-calc]');
  const outKd = calc && calc.querySelector('[data-calc-kd]');
  const outUsd = calc && calc.querySelector('[data-calc-usd]');
  const compute = () => {
    if (!calc || !prices) return;
    const w = parseFloat(String(calc.elements.w.value).replace(',', '.'));
    const k = (calc.querySelector('input[name="k"]:checked') || {}).value || 'k21';
    const p = prices[k];
    if (!p || !(w >= 0)) { outKd.textContent = '—'; outUsd.textContent = '—'; return; }
    outKd.textContent = f3.format(w * p[0]);
    outUsd.textContent = '$' + f2.format(w * p[1]);
  };
  if (calc) {
    calc.addEventListener('input', compute);
    calc.addEventListener('change', compute);
  }

  /* ---------- 2. quiet refresh from the public endpoint ---------- */
  const endpoint = root.getAttribute('data-endpoint');
  const asof = Date.parse(root.getAttribute('data-asof') || '');
  const market = root.getAttribute('data-market');
  const old = !isFinite(asof) || (market !== 'closed' && Date.now() - asof > 30 * 60 * 1000);
  if (!endpoint || !old) return;

  const set = (key, text) => root.querySelectorAll('[data-sg="' + key + '"]').forEach((el) => {
    if (el.textContent !== text) { el.textContent = text; el.classList.add('sg-flash'); setTimeout(() => el.classList.remove('sg-flash'), 900); }
  });
  fetch(endpoint, { headers: { Accept: 'application/json' }, cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then((q) => {
      if (!q || !q.gold) return;
      const g = q.gold, gu = g.usd_g || {};
      ['k24', 'k22', 'k21', 'k18'].forEach((k) => {
        if (typeof g[k] === 'number') set(k + '.kwd', f3.format(g[k]));
        if (typeof gu[k] === 'number') set(k + '.usd', f2.format(gu[k]));
      });
      if (typeof g.usd_oz === 'number') {
        set('oz.usd', f2.format(g.usd_oz));
        if (typeof q.usd_kwd === 'number') set('oz.kwd', f3.format(g.usd_oz * q.usd_kwd));
      }
      if (q.silver && typeof q.silver.g999 === 'number') set('ag.kwd', f3.format(q.silver.g999));
      // the calculator follows the newest prices
      prices = prices || {};
      ['k24', 'k22', 'k21', 'k18'].forEach((k) => { if (typeof g[k] === 'number' && typeof gu[k] === 'number') prices[k] = [g[k], gu[k]]; });
      compute();
      // time stamp
      const when = root.querySelector('[data-sg-when]');
      const t = q.asof ? new Date(q.asof) : null;
      if (when && t && isFinite(t.getTime())) {
        when.setAttribute('datetime', q.asof);
        when.textContent = new Intl.DateTimeFormat(lang === 'ar' ? 'ar-KW-u-nu-latn' : 'en-GB', {
          hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Kuwait',
        }).format(t);
      }
      const loading = root.querySelector('[data-sg-loading]');
      if (loading) loading.hidden = true;
    })
    .catch(() => {});
})();
